import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

/** Resolve relative backend URLs (e.g. /api/users/x/avatar?v=...) to absolute. */
function resolveAvatarUrl(src) {
  if (!src) return null;
  if (src.startsWith("/")) return `${API_BASE}${src}`;
  return src;
}

/**
 * Brand-flavored avatar: shows the user's picture when available, otherwise
 * the orange "hand" mark on a soft brand background. Wraps shadcn Avatar so
 * sizing/className work the same.
 */
export const BrandAvatar = React.forwardRef(function BrandAvatar(
  { src, alt = "", className = "", imgClassName = "", fallbackClassName = "" },
  ref,
) {
  const resolved = resolveAvatarUrl(src);
  return (
    <Avatar ref={ref} className={className}>
      {resolved ? <AvatarImage src={resolved} alt={alt} className={imgClassName} /> : null}
      <AvatarFallback
        className={`bg-brand/10 p-0 overflow-hidden ${fallbackClassName}`}
      >
        <img
          src="/favicon.png"
          alt="We Speak Spanish"
          className="w-3/4 h-3/4 object-contain"
          loading="lazy"
        />
      </AvatarFallback>
    </Avatar>
  );
});
